import { LegalFile, UpdateLegalFile, ReplaceLegalFile } from "records/brand/brand";
import { BRAND } from "constants/action-types";

export const addLegalFiles = (files: Partial<LegalFile>[]) => ({ type: BRAND.LEGAL_FILES.ADD.START, payload: files });

export const deleteLegalFiles = (ids: LegalFile["_id"][]) => ({ type: BRAND.LEGAL_FILES.DELETE.START, payload: ids });

export const replaceLegalFile = (file: ReplaceLegalFile) => ({ type: BRAND.LEGAL_FILES.REPLACE.START, payload: file });

export const updateLegalFile = (file: UpdateLegalFile) => ({ type: BRAND.LEGAL_FILES.UPDATE.START, payload: file });

export const fetchLegalFiles = () => ({ type: BRAND.LEGAL_FILES.FETCH.START });
